import { createIndexCache, createKeyedResourceCache } from "./apiResourceCache";

export const getLocations = createIndexCache("/public/locations");

const getLocationItemsCached = createKeyedResourceCache({
  fetchPath: (key) => `/public/locations/${encodeURIComponent(key)}`,
  normalizeKey: (countryCode) => countryCode.toUpperCase(),
  transform: (data, key) => ({
    countryCode: data?.countryCode || key,
    name: data?.name || key,
    items: Array.isArray(data?.items) ? data.items : [],
  }),
});

export async function getLocationItems(countryCode) {
  if (!countryCode) return { name: countryCode, items: [] };
  return getLocationItemsCached(countryCode);
}

export function prefetchLocationItems(countryCode) {
  if (!countryCode) return;
  void getLocationItems(countryCode);
}

/** Warm `/public/locations` so the Locations tab is instant after idle or hover. */
export function prefetchLocationsIndex() {
  void getLocations();
}
